module.exports = __webpack_public_path__ + "static/media/hand-holding-magic.821cb90b.svg";